import { Component, inject, OnInit } from '@angular/core';
import { EpdfType } from '../../../../components/core/models/instruments.enum';
import { NgxButtonComponent } from '@digipay/ngx-button';

import { IProspectusRouteState } from '../../../../components/core/models/prospectus-route-state.interface';
import { CHOICE_PAYMENT_METHOD_ROUTE, PROSPECTUS_ROUTE } from '../../../../data-access/constants/app-routes';
import { WealthNavigationService } from '@client-monorepo/wealth/navigation';
import { BaseComponent } from '../../../../components/core/components/base/base.component';
import { IPOService } from '../../../ipo/services/ipo.service';
import { ActivatedRoute } from '@angular/router';
import { RouteStateService } from '@client-monorepo/common/utilities';
import { IPayment } from '../../../../components/core/models/payment.interface';
import { PaymentHandlerService } from '../../../purchase/services/payment-handler.service';
import { takeUntil } from 'rxjs';
import { NgxAppBarComponent } from '@digipay/ngx-app-bar';
import { NgxCheckboxComponent } from '@digipay/ngx-checkbox';
import { SpinnerComponent } from '../../../../shared/components/spinner/spinner.component';

@Component({
  selector: 'wealth-applet-payment-conditions',
  standalone: true,
  imports: [NgxButtonComponent, NgxAppBarComponent, NgxCheckboxComponent, SpinnerComponent],
  templateUrl: './payment-conditions.component.html',
  styleUrl: './payment-conditions.component.scss',
})
export class PaymentConditionsComponent extends BaseComponent implements OnInit {
  protected readonly pdfType = EpdfType;
  agreementChecked: boolean;
  symbol: string;
  agreements: string[] = [];
  state: { [key: string]: any };
  loading = true;
  btnLoading = false;

  private ipoService = inject(IPOService);
  private routeState = inject(RouteStateService);
  private activatedRoute = inject(ActivatedRoute);
  private navigationService = inject(WealthNavigationService);
  private paymentHandlerService = inject(PaymentHandlerService);

  constructor() {
    super();
    this.symbol = this.activatedRoute.snapshot.params['symbol'];
    this.state = this.routeState.getAll();
  }

  ngOnInit() {
    if (!this.state?.['agreementType']) {
      this.onBackHandler();
    } else {
      this.ipoService
        .getAgreements(this.symbol, this.state['agreementType'])
        .pipe(takeUntil(this.destroyObservable))
        .subscribe((agreements) => {
          if (agreements?.success) {
            this.agreements = agreements.result.agreements;
          }

          this.loading = false;
        });

      this.paymentHandlerService.loading$.pipe(takeUntil(this.destroyObservable)).subscribe((res) => {
        this.btnLoading = res;
      });
    }
  }

  onToggleAgreement(event: any) {
    this.agreementChecked = event;
  }

  agreementView(RISKSTATEMEBT: EpdfType) {
    const state: IProspectusRouteState = {
      symbol: this.symbol,
      backToProfile: false,
      pdfType: RISKSTATEMEBT,
      type: 'IPO',
    };
    this.navigationService.navigate([PROSPECTUS_ROUTE], {
      state: state,
    });
  }

  continue() {
    this.btnLoading = true;
    const payment: IPayment = this.generatePaymentData();
    this.paymentHandlerService.setPayment(payment);
    this.paymentHandlerService.paymentConfirm();
  }

  onBackHandler() {
    this.navigationService.navigate([CHOICE_PAYMENT_METHOD_ROUTE, this.symbol]);
  }

  private generatePaymentData(): IPayment {
    return {
      symbol: this.symbol,
      amount: 0,
      agreementChecked: true,
      instrumentUnit: 0,
      units: 0,
      type: 'IPO',
      assetData: this.state['assetData'],
      ipoPaymentMethod: this.state?.['agreementType'],
    };
  }
}
